import { render } from "./App.vue?vue&type=template&id=33b9d4ba"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=33b9d4ba&lang=css"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__